import { render, staticRenderFns } from "./textTitle6.vue?vue&type=template&id=42be9dcc&scoped=true"
import script from "./textTitle6.vue?vue&type=script&lang=js"
export * from "./textTitle6.vue?vue&type=script&lang=js"
import style0 from "./textTitle6.vue?vue&type=style&index=0&id=42be9dcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be9dcc",
  null
  
)

export default component.exports